import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {AnnuityLetterService} from 'src/app/services/annuity-letter.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';

@Component({
  selector: 'app-annuity-payment',
  templateUrl: './annuity-payment.component.html',
  styleUrls: [ './annuity-payment.component.scss' ]
})
export class AnnuityPaymentComponent implements OnInit {

  public type: any;

  public error: any;
  public qrCode: any;
  public qrCodeImage: any;

  public identificationField: any;
  public barCode: any;
  public nossoNumero: any;
  public bankSlipUrl: any;

  public letter_dateSent: any;
  public letter_dateRead: any;
  public letter_datePayed: any;
  public letter_sent_id: string;

  public member_name:string;
  public category_name: string;

  constructor (
    private _sanitizer: DomSanitizer,
    private _snackBar: SnackBarIconService,
    private _annuityLetterService: AnnuityLetterService,
    private _router: Router,
  ) { }

  ngOnInit () {
    const cookie: any = JSON.parse(sessionStorage.getItem("sbap-payed"));

    this.type = cookie.type;

    this.error = cookie.status != "success"

    console.log("error: " + this.error);
    // console.log("cookie: " + JSON.stringify(cookie));

    switch (this.type) {
      case "Pix":
      case "PIX": {
        this.qrCodeImage = this.getSafeUrl(cookie.data.qrCodeBase64Image); //encodedImage
        this.qrCode = cookie.data.qrCodeString; //payload
      }
        break;
      case "BOLETO": {
        this.identificationField = this.linhaDigitavelFormatada(cookie.data.identificationField);
        this.barCode = cookie.data.barCode;
        this.nossoNumero = cookie.data.nossoNumero;
        this.bankSlipUrl = cookie.data.bankSlipUrl // ? cookie.data.bankSlipUrl : "https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Flogos%2Fsbccv_logo.png?alt=media&token=8c5cbbab-9e24-43b8-bc89-869735fe32b3";
      }
        break;
    }

    this.letter_sent_id = cookie.letter_sent_id;
    this.getLetterSnapshotChanges(this.letter_sent_id)

  }

  linhaDigitavelFormatada (linha) {
    return `${ linha.substring(0, 5) }.${ linha.substring(5, 10) } ${ linha.substring(10, 15) }.${ linha.substring(15, 21) } ${ linha.substring(21, 26) }.${ linha.substring(26, 32) } ${ linha.substring(32, 33) } ${ linha.substring(33) }`;
  }

  getSafeUrl (base64: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64,${ base64 }`);
  }

  async copyToClipboard (data) {
    await navigator.clipboard.writeText(data);
    this._snackBar.openSnackBar("Código copiado", '', 'success')
  }

  async getLetterSnapshotChanges (letter_id: string) {
    //console.log("lettter_id: " + letter_id);
    this._annuityLetterService.getLetterSnapshotChanges(letter_id)
      .subscribe((result: any) => {
        // console.log("letter_id: " + letter_id)

        this.letter_dateSent = result.payload.data().dateSent;
        this.letter_dateRead = result.payload.data().dateRead;
        this.letter_datePayed = result.payload.data().datePayed;

        this.member_name = result.payload.data().name;
        this.category_name = result.payload.data().subCategory_name;

        // console.log("sent: " + this.letter_dateSent);
        // console.log("read: " + this.letter_dateRead);
        // console.log("payed: " + this.letter_datePayed);

        if(this.letter_datePayed){

        }

      })


  }

  goBack () {
    this._router.navigate([ 'annuity-back/' + this.letter_sent_id ]);
  }

  gotoInvoiceAndReceipt(){
     this._router.navigate([ 'annuity-back/' + this.letter_sent_id ]);
  }
}
